import { render } from "./SecondaryButton.vue?vue&type=template&id=46be162c&scoped=true"
import script from "./SecondaryButton.vue?vue&type=script&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&lang=js"

import "./SecondaryButton.vue?vue&type=style&index=0&id=46be162c&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46be162c"]])

export default __exports__